import { Component, OnInit } from '@angular/core';
import { Theme } from '../../../data/theme.model';
import { StoreService } from '../../../data/store.service';
import { MsgService } from '../../../utils/message/msg.service';
import { I18ns } from '../../../utils/i18n/I18n';
import { SharedModule } from '../../../utils/shared.module';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-game-picker',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './game-picker.component.html',
  styleUrl: './game-picker.component.scss',
})
export class GamePickerComponent implements OnInit {
  URL = environment.url;

  theme?: Theme;
  protected readonly I18ns = I18ns;

  constructor(
    public readonly store: StoreService,
    private readonly msg: MsgService,
  ) {}

  ngOnInit() {
    if (!this.store.theme()?.id) {
      this.msg.add({
        message: I18ns.grid.noTheme,
        severity: 'error',
      });
      return;
    }
    this.msg.clear();

    this.theme = this.store.theme();
  }
}
